module.exports = __webpack_public_path__ + "static/media/chair-busy-small.3a5b1d53.png";